import type { TagDTO } from '~/shared/api/client/tags/tags.dto';

interface PartnerMarkedItem {
  category?: TagDTO | null;
  mark_disable_datetime?: string | null;
}

/** An article (news item or expert opinion) with a partner root tag */
export const isPartnerArticle = (item?: PartnerMarkedItem | null): boolean =>
  Boolean(item?.category?.is_partner);

/** The ad mark is visible until the "disable ad" datetime has passed */
export const isAdMarkVisible = (item?: PartnerMarkedItem | null): boolean =>
  isPartnerArticle(item) &&
  (!item?.mark_disable_datetime ||
    new Date(item.mark_disable_datetime).getTime() > Date.now());
